interface _cesionDerecho {
    id: number;
    rfc: string;
    id_solicitud: number;
    docSolicitud: any;
    id_solicitud_ant:number;
    docSolicitudAnt:any;
    id_local_mercado:number;
    id_cesionario:number;
    familiar: Boolean;
    id_foto_cesionario:number;
    docFoto:any;
    id_baja_sat:number;
    docBajaSat:any;
    id_alta_sat:number;
    docAltaSat:any;
    id_autorizacion_sec:number;
    docAutorizacion:any;
    id_acta_comp:number;
    docActaComp:any;
    estatus:number;
    motivo_rechazo:string;
    id_edo_cuenta:number;
    docEdoCuenta:any;
    locacion:number;
    id_recibo_pago:number;
    docSolidPago:any;
    baja_form_licen_concesionario:number;
    docBaja_form_licen_concesionario:any;
}

class cesionDerecho implements _cesionDerecho {
    id=0;
    rfc='';
    id_solicitud=0;
    docSolicitud=null;
    id_solicitud_ant=0;
    docSolicitudAnt=null;
    id_local_mercado=0;
    id_cesionario=0;
    familiar=false;
    id_foto_cesionario=0;
    docFoto=null;
    id_baja_sat=0;
    docBajaSat=null;
    id_alta_sat=0;
    docAltaSat=null;
    id_autorizacion_sec=0;
    docAutorizacion=null;
    id_acta_comp=0;
    docActaComp=null;
    estatus=0;
    motivo_rechazo='';
    id_edo_cuenta=0;
    docEdoCuenta=null;
    locacion=0;
    id_recibo_pago = 0;
    docSolidPago=null;
    baja_form_licen_concesionario = 0;
    docBaja_form_licen_concesionario=null;
}

export { cesionDerecho, _cesionDerecho }